export const DEFAULT_PRIMARY_FONT = "Manrope";
export const DEFAULT_SECONDARY_FONT = "Thicker";

export function hexToRgba(hex: string, alpha = 1): string {
	const normalizedHex = hex.trim();
	if (!/^#[0-9A-Fa-f]{6}$/.test(normalizedHex)) {
		return `rgba(26, 26, 26, ${alpha})`;
	}
	const r = parseInt(normalizedHex.slice(1, 3), 16);
	const g = parseInt(normalizedHex.slice(3, 5), 16);
	const b = parseInt(normalizedHex.slice(5, 7), 16);

	return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
